<script>
import { useCredentialsStore } from '@/stores/credentials.js';
import SatelliteApi from '@/data/SatelliteApi.ts';
import { useMetersStore } from '@/stores/meters.ts';
import ViewHeader from '@/components/ViewHeader.vue';

export default {
  name: 'SignInView',
  components: { ViewHeader },
  data() {
    return {
      welcomeText: 'Inloggen',
      plantCode: '',
      postalCode: '',
      errorMsg: null,
      ongoingCall: false,
    };
  },
  computed: {
    disableSignInButton() {
      return !this.postalCode || !this.plantCode || this.ongoingCall;
    },
  },
  methods: {
    attemptSignIn() {
      this.errorMsg = null;
      this.ongoingCall = true;
      new SatelliteApi()
        .getOverviewOfMeters(
          this.postalCode.toUpperCase(),
          this.plantCode.toUpperCase(),
        )
        .then(this.handleSuccessfulSignIn)
        .catch((error) => (this.errorMsg = error.response.data.message ?? 'Ongeldige inloggegevens'))
        .finally(() => (this.ongoingCall = false));
    },
    handleSuccessfulSignIn(rsp) {
      useCredentialsStore().set(
        this.postalCode.toUpperCase(),
        this.plantCode.toUpperCase(),
      );
      useMetersStore().set(rsp.data);
      this.$router.push({ name: 'select-meter' });
    },
  },
};
</script>

<template>
  <div class="my-auto">
    <div class="grow mx-12 align-middle border p-6 rounded-xl">
      <!--    <view-header title="Inloggen" />-->
      <div class="text-lg text-justify">{{ welcomeText }}</div>
      <div v-if="errorMsg">{{ errorMsg }}</div>

      <FloatLabel class="mt-6">
        <label for="f-postal-code">Postcode</label>
        <InputText id="f-postal-code" class="w-full" v-model="postalCode"/>
      </FloatLabel>

      <FloatLabel class="mt-6">
        <label for="f-plant-code">Code</label>
        <InputText id="f-plant-code" class="w-full" v-model="plantCode"/>
      </FloatLabel>

      <Button class="w-full mt-7" @mousedown="attemptSignIn" :disabled="disableSignInButton">
        Inloggen
      </Button>
      <div class="mt-2 text-xs text-gray-400 text-center">powered by Sundata</div>
    </div>
  </div>
</template>

<style scoped></style>
